webpackJsonp([257593722917106],{

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(52);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _util = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var gradients = [{
	  name: 'Berimbolo',
	  colors: ['#02111D', '#037BB5', '#02111D']
	}, {
	  name: 'Mango',
	  colors: ['#ffe259', '#ffa751']
	}, {
	  name: 'Windy',
	  colors: ['#acb6e5', '#86fde8']
	}, {
	  name: 'Royal Blue',
	  colors: ['#536976', '#292E49']
	}, {
	  name: 'Royal Blue + Petrol',
	  colors: ['#BBD2C5', '#536976', '#292E49']
	}, {
	  name: 'Copper',
	  colors: ['#B79891', '#94716B']
	}, {
	  name: 'Petrol',
	  colors: ['#BBD2C5', '#536976']
	}, {
	  name: 'Sky',
	  colors: ['#076585', '#fff']
	}, {
	  name: 'Sel',
	  colors: ['#00467F', '#A5CC82']
	}, {
	  name: 'Skyline',
	  colors: ['#1488CC', '#2B32B2']
	}, {
	  name: 'DIMIGO',
	  colors: ['#ec008c', '#fc6767']
	}, {
	  name: 'Purple Love',
	  colors: ['#cc2b5e', '#753a88']
	}, {
	  name: 'Sexy Blue',
	  colors: ['#2193b0', '#6dd5ed']
	}, {
	  name: 'Blooker20',
	  colors: ['#e65c00', '#F9D423']
	}, {
	  name: 'Sea Blue',
	  colors: ['#2b5876', '#4e4376']
	}, {
	  name: 'Nimvelo',
	  colors: ['#314755', '#26a0da']
	}, {
	  name: 'Hazel',
	  colors: ['#77A1D3', '#79CBCA', '#E684AE']
	}, {
	  name: 'Noon to Dusk',
	  colors: ['#ff6e7f', '#bfe9ff']
	}, {
	  name: 'YouTube',
	  colors: ['#e52d27', '#b31217']
	}, {
	  name: 'Cool Brown',
	  colors: ['#603813', '#b29f94']
	}, {
	  name: 'Harmonic Energy',
	  colors: ['#16A085', '#F4D03F']
	}, {
	  name: 'Playing with Reds',
	  colors: ['#D31027', '#EA384D']
	}, {
	  name: 'Sunny Days',
	  colors: ['#EDE574', '#E1F5C4']
	}, {
	  name: 'Green Beach',
	  colors: ['#02AAB0', '#00CDAC']
	}, {
	  name: 'Intuitive Purple',
	  colors: ['#DA22FF', '#9733EE']
	}, {
	  name: 'Emerald Water',
	  colors: ['#348F50', '#56B4D3']
	}, {
	  name: 'Lemon Twist',
	  colors: ['#3CA55C', '#B5AC49']
	}, {
	  name: 'Monte Carlo',
	  colors: ['#CC95C0', '#DBD4B4', '#7AA1D2']
	}, {
	  name: 'Horizon',
	  colors: ['#003973', '#E5E5BE']
	}, {
	  name: 'Rose Water',
	  colors: ['#E55D87', '#5FC3E4']
	}, {
	  name: 'Frozen',
	  colors: ['#403B4A', '#E7E9BB']
	}, {
	  name: 'Mango Pulp',
	  colors: ['#F09819', '#EDDE5D']
	}, {
	  name: 'Bloody Mary',
	  colors: ['#FF512F', '#DD2476']
	}, {
	  name: 'Aubergine',
	  colors: ['#AA076B', '#61045F']
	}, {
	  name: 'Aqua Marine',
	  colors: ['#1A2980', '#26D0CE']
	}, {
	  name: 'Sunrise',
	  colors: ['#FF512F', '#F09819']
	}, {
	  name: 'Purple Paradise',
	  colors: ['#1D2B64', '#F8CDDA']
	}, {
	  name: 'Stripe',
	  colors: ['#1FA2FF', '#12D8FA', '#A6FFCB']
	}, {
	  name: 'Sea Weed',
	  colors: ['#4CB8C4', '#3CD3AD']
	}, {
	  name: 'Pinky',
	  colors: ['#DD5E89', '#F7BB97']
	}, {
	  name: 'Cherry',
	  colors: ['#EB3349', '#F45C43']
	}, {
	  name: 'Mojito',
	  colors: ['#1D976C', '#93F9B9']
	}, {
	  name: 'Juicy Orange',
	  colors: ['#FF8008', '#FFC837']
	}, {
	  name: 'Mirage',
	  colors: ['#16222A', '#3A6073']
	}, {
	  name: 'Steel Gray',
	  colors: ['#1F1C2C', '#928DAB']
	}, {
	  name: 'Kashmir',
	  colors: ['#614385', '#516395']
	}, {
	  name: 'Electric Violet',
	  colors: ['#4776E6', '#8E54E9']
	}, {
	  name: 'Venice Blue',
	  colors: ['#085078', '#85D8CE']
	}, {
	  name: 'Bora Bora',
	  colors: ['#2BC0E4', '#EAECC6']
	}, {
	  name: 'Moss',
	  colors: ['#134E5E', '#71B280']
	}, {
	  name: 'Shroom Haze',
	  colors: ['#5C258D', '#4389A2']
	}, {
	  name: 'Mystic',
	  colors: ['#757F9A', '#D7DDE8']
	}, {
	  name: 'Midnight City',
	  colors: ['#232526', '#414345']
	}, {
	  name: 'Sea Blizz',
	  colors: ['#1CD8D2', '#93EDC7']
	}, {
	  name: 'Opa',
	  colors: ['#3D7EAA', '#FFE47A']
	}, {
	  name: 'Titanium',
	  colors: ['#283048', '#859398']
	}, {
	  name: 'Mantle',
	  colors: ['#24C6DC', '#514A9D']
	}, {
	  name: 'Dracula',
	  colors: ['#DC2424', '#4A569D']
	}, {
	  name: 'Peach',
	  colors: ['#ED4264', '#FFEDBC']
	}, {
	  name: 'Moonrise',
	  colors: ['#DAE2F8', '#D6A4A4']
	}, {
	  name: 'Clouds',
	  colors: ['#ECE9E6', '#FFFFFF']
	}, {
	  name: 'Stellar',
	  colors: ['#7474BF', '#348AC7']
	}, {
	  name: 'Bourbon',
	  colors: ['#EC6F66', '#F3A183']
	}, {
	  name: 'Calm Darya',
	  colors: ['#5f2c82', '#49a09d']
	}, {
	  name: 'Influenza',
	  colors: ['#C04848', '#480048']
	}, {
	  name: 'Shrimpy',
	  colors: ['#e43a15', '#e65245']
	}, {
	  name: 'Army',
	  colors: ['#414d0b', '#727a17']
	}, {
	  name: 'Miaka',
	  colors: ['#FC354C', '#0ABFBC']
	}, {
	  name: 'Pinot Noir',
	  colors: ['#4b6cb7', '#182848']
	}, {
	  name: 'Day Tripper',
	  colors: ['#f857a6', '#ff5858']
	}, {
	  name: 'Namn',
	  colors: ['#a73737', '#7a2828']
	}, {
	  name: 'Blurry Beach',
	  colors: ['#d53369', '#cbad6d']
	}, {
	  name: 'Vasily',
	  colors: ['#e9d362', '#333333']
	}, {
	  name: 'A Lost Memory',
	  colors: ['#DE6262', '#FFB88C']
	}, {
	  name: 'Petrichor',
	  colors: ['#666600', '#999966']
	}, {
	  name: 'Jonquil',
	  colors: ['#FFEEEE', '#DDEFBB']
	}, {
	  name: 'Sirius Tamed',
	  colors: ['#EFEFBB', '#D4D3DD']
	}, {
	  name: 'Kyoto',
	  colors: ['#c21500', '#ffc500']
	}, {
	  name: 'Misty Meadow',
	  colors: ['#215f00', '#e4e4d9']
	}, {
	  name: 'Aqualicious',
	  colors: ['#50C9C3', '#96DEDA']
	}, {
	  name: 'Moor',
	  colors: ['#616161', '#9bc5c3']
	}, {
	  name: 'Almost',
	  colors: ['#ddd6f3', '#faaca8']
	}, {
	  name: 'Forever Lost',
	  colors: ['#5D4157', '#A8CABA']
	}, {
	  name: 'Winter',
	  colors: ['#E6DADA', '#274046']
	}, {
	  name: 'Autumn',
	  colors: ['#DAD299', '#B0DAB9']
	}, {
	  name: 'Candy',
	  colors: ['#D3959B', '#BFE6BA']
	}, {
	  name: 'Reef',
	  colors: ['#00d2ff', '#3a7bd5']
	}, {
	  name: 'The Strain',
	  colors: ['#870000', '#190A05']
	}, {
	  name: 'Dirty Fog',
	  colors: ['#B993D6', '#8CA6DB']
	}, {
	  name: 'Earthly',
	  colors: ['#649173', '#DBD5A4']
	}, {
	  name: 'Virgin',
	  colors: ['#C9FFBF', '#FFAFBD']
	}, {
	  name: 'Ash',
	  colors: ['#606c88', '#3f4c6b']
	}, {
	  name: 'Shadow Night',
	  colors: ['#000000', '#53346D']
	}, {
	  name: 'Cherryblossoms',
	  colors: ['#FBD3E9', '#BB377D']
	}, {
	  name: 'Parklife',
	  colors: ['#ADD100', '#7B920A']
	}, {
	  name: 'Dance To Forget',
	  colors: ['#FF4E50', '#F9D423']
	}, {
	  name: 'Starfall',
	  colors: ['#F0C27B', '#4B1248']
	}, {
	  name: 'Red Mist',
	  colors: ['#000000', '#e74c3c']
	}, {
	  name: 'Teal Love',
	  colors: ['#AAFFA9', '#11FFBD']
	}, {
	  name: 'Neon Life',
	  colors: ['#B3FFAB', '#12FFF7']
	}, {
	  name: 'Man of Steel',
	  colors: ['#780206', '#061161']
	}, {
	  name: 'Amethyst',
	  colors: ['#9D50BB', '#6E48AA']
	}, {
	  name: 'Cheer Up Emo Kid',
	  colors: ['#556270', '#FF6B6B']
	}, {
	  name: 'Shore',
	  colors: ['#70e1f5', '#ffd194']
	}, {
	  name: 'Facebook Messenger',
	  colors: ['#00c6ff', '#0072ff']
	}, {
	  name: 'SoundCloud',
	  colors: ['#fe8c00', '#f83600']
	}, {
	  name: 'Behongo',
	  colors: ['#52c234', '#061700']
	}, {
	  name: 'ServQuick',
	  colors: ['#485563', '#29323c']
	}, {
	  name: 'Friday',
	  colors: ['#83a4d4', '#b6fbff']
	}, {
	  name: 'Martini',
	  colors: ['#FDFC47', '#24FE41']
	}, {
	  name: 'Metallic Toad',
	  colors: ['#abbaab', '#ffffff']
	}, {
	  name: 'Between The Clouds',
	  colors: ['#73C8A9', '#373B44']
	}, {
	  name: 'Crazy Orange I',
	  colors: ['#D38312', '#A83279']
	}, {
	  name: 'Hersheys',
	  colors: ['#1e130c', '#9a8478']
	}, {
	  name: 'Talking To Mice Elf',
	  colors: ['#948E99', '#2E1437']
	}, {
	  name: 'Purple Bliss',
	  colors: ['#360033', '#0b8793']
	}, {
	  name: 'Predawn',
	  colors: ['#FFA17F', '#00223E']
	}, {
	  name: 'Endless River',
	  colors: ['#43cea2', '#185a9d']
	}, {
	  name: 'Pastel Orange at the Sun',
	  colors: ['#ffb347', '#ffcc33']
	}, {
	  name: 'Twitch',
	  colors: ['#6441A5', '#2a0845']
	}, {
	  name: 'Atlas',
	  colors: ['#FEAC5E', '#C779D0', '#4BC0C8']
	}, {
	  name: 'Instagram',
	  colors: ['#833ab4', '#fd1d1d', '#fcb045']
	}, {
	  name: 'Flickr',
	  colors: ['#ff0084', '#33001b']
	}, {
	  name: 'Vine',
	  colors: ['#00bf8f', '#001510']
	}, {
	  name: 'Turquoise flow',
	  colors: ['#136a8a', '#267871']
	}, {
	  name: 'Portrait',
	  colors: ['#8e9eab', '#eef2f3']
	}, {
	  name: 'Virgin America',
	  colors: ['#7b4397', '#dc2430']
	}, {
	  name: 'Koko Caramel',
	  colors: ['#D1913C', '#FFD194']
	}, {
	  name: 'Fresh Turboscent',
	  colors: ['#F1F2B5', '#135058']
	}, {
	  name: 'Green to dark',
	  colors: ['#6A9113', '#141517']
	}, {
	  name: 'Ukraine',
	  colors: ['#004FF9', '#FFF94C']
	}, {
	  name: 'Curiosity blue',
	  colors: ['#525252', '#3d72b4']
	}, {
	  name: 'Dark Knight',
	  colors: ['#BA8B02', '#181818']
	}, {
	  name: 'Piglet',
	  colors: ['#ee9ca7', '#ffdde1']
	}, {
	  name: 'Lizard',
	  colors: ['#304352', '#d7d2cc']
	}, {
	  name: 'Sage Persuasion',
	  colors: ['#CCCCB2', '#757519']
	}, {
	  name: 'Between Night and Day',
	  colors: ['#2c3e50', '#3498db']
	}, {
	  name: 'Timber',
	  colors: ['#fc00ff', '#00dbde']
	}, {
	  name: 'Passion',
	  colors: ['#e53935', '#e35d5b']
	}, {
	  name: 'Clear Sky',
	  colors: ['#005C97', '#363795']
	}, {
	  name: 'Master Card',
	  colors: ['#f46b45', '#eea849']
	}, {
	  name: 'Back To Earth',
	  colors: ['#00C9FF', '#92FE9D']
	}, {
	  name: 'Deep Purple',
	  colors: ['#673AB7', '#512DA8']
	}, {
	  name: 'Little Leaf',
	  colors: ['#76b852', '#8DC26F']
	}, {
	  name: 'Netflix',
	  colors: ['#8E0E00', '#1F1C18']
	}, {
	  name: 'Light Orange',
	  colors: ['#FFB75E', '#ED8F03']
	}, {
	  name: 'Green and Blue',
	  colors: ['#c2e59c', '#64b3f4']
	}, {
	  name: 'Poncho',
	  colors: ['#403A3E', '#BE5869']
	}, {
	  name: 'Back to the Future',
	  colors: ['#C02425', '#F0CB35']
	}, {
	  name: 'Blush',
	  colors: ['#B24592', '#F15F79']
	}, {
	  name: 'Inbox',
	  colors: ['#457fca', '#5691c8']
	}, {
	  name: 'Purplin',
	  colors: ['#6a3093', '#a044ff']
	}, {
	  name: 'Pale Wood',
	  colors: ['#eacda3', '#d6ae7b']
	}, {
	  name: 'Haikus',
	  colors: ['#fd746c', '#ff9068']
	}, {
	  name: 'Pizelex',
	  colors: ['#114357', '#F29492']
	}, {
	  name: 'Joomla',
	  colors: ['#1e3c72', '#2a5298']
	}, {
	  name: 'Christmas',
	  colors: ['#2F7336', '#AA3A38']
	}, {
	  name: 'Minnesota Vikings',
	  colors: ['#5614B0', '#DBD65C']
	}, {
	  name: 'Miami Dolphins',
	  colors: ['#4DA0B0', '#D39D38']
	}, {
	  name: 'Forest',
	  colors: ['#5A3F37', '#2C7744']
	}, {
	  name: 'Nighthawk',
	  colors: ['#2980b9', '#2c3e50']
	}, {
	  name: 'Superman',
	  colors: ['#0099F7', '#F11712']
	}, {
	  name: 'Suzy',
	  colors: ['#834d9b', '#d04ed6']
	}, {
	  name: 'Dark Skies',
	  colors: ['#4B79A1', '#283E51']
	}, {
	  name: 'Deep Space',
	  colors: ['#000000', '#434343']
	}, {
	  name: 'Decent',
	  colors: ['#4CA1AF', '#C4E0E5']
	}, {
	  name: 'Colors Of Sky',
	  colors: ['#E0EAFC', '#CFDEF3']
	}, {
	  name: 'Purple White',
	  colors: ['#BA5370', '#F4E2D8']
	}, {
	  name: 'Ali',
	  colors: ['#ff4b1f', '#1fddff']
	}, {
	  name: 'Alihossein',
	  colors: ['#f7ff00', '#db36a4']
	}, {
	  name: 'Shahabi',
	  colors: ['#a80077', '#66ff00']
	}, {
	  name: 'Red Ocean',
	  colors: ['#1D4350', '#A43931']
	}, {
	  name: 'Tranquil',
	  colors: ['#EECDA3', '#EF629F']
	}, {
	  name: 'Transfile',
	  colors: ['#16BFFD', '#CB3066']
	}, {
	  name: 'Sylvia',
	  colors: ['#ff4b1f', '#ff9068']
	}, {
	  name: 'Sweet Morning',
	  colors: ['#FF5F6D', '#FFC371']
	}, {
	  name: 'Politics',
	  colors: ['#2196f3', '#f44336']
	}, {
	  name: 'Bright Vault',
	  colors: ['#00d2ff', '#928DAB']
	}, {
	  name: 'Solid Vault',
	  colors: ['#3a7bd5', '#3a6073']
	}, {
	  name: 'Sunset',
	  colors: ['#0B486B', '#F56217']
	}, {
	  name: 'Grapefruit Sunset',
	  colors: ['#e96443', '#904e95']
	}, {
	  name: 'Deep Sea Space',
	  colors: ['#2C3E50', '#4CA1AF']
	}, {
	  name: 'Dusk',
	  colors: ['#2C3E50', '#FD746C']
	}, {
	  name: 'Minimal Red',
	  colors: ['#F00000', '#DC281E']
	}, {
	  name: 'Royal',
	  colors: ['#141E30', '#243B55']
	}, {
	  name: 'Mauve',
	  colors: ['#42275a', '#734b6d']
	}, {
	  name: 'Frost',
	  colors: ['#000428', '#004e92']
	}, {
	  name: 'Lush',
	  colors: ['#56ab2f', '#a8e063']
	}, {
	  name: 'Firewatch',
	  colors: ['#cb2d3e', '#ef473a']
	}, {
	  name: 'Sherbert',
	  colors: ['#f79d00', '#64f38c']
	}, {
	  name: 'Blood Red',
	  colors: ['#f85032', '#e73827']
	}, {
	  name: 'Sun on the Horizon',
	  colors: ['#fceabb', '#f8b500']
	}, {
	  name: 'IIIT Delhi',
	  colors: ['#808080', '#3fada8']
	}, {
	  name: 'Dusk',
	  colors: ['#ffd89b', '#19547b']
	}, {
	  name: '50 Shades of Grey',
	  colors: ['#bdc3c7', '#2c3e50']
	}, {
	  name: 'Dania',
	  colors: ['#BE93C5', '#7BC6CC']
	}, {
	  name: 'Limeade',
	  colors: ['#A1FFCE', '#FAFFD1']
	}, {
	  name: 'Disco',
	  colors: ['#4ECDC4', '#556270']
	}, {
	  name: 'Love Couple',
	  colors: ['#3a6186', '#89253e']
	}, {
	  name: 'Azure Pop',
	  colors: ['#ef32d9', '#89fffd']
	}, {
	  name: 'Nepal',
	  colors: ['#de6161', '#2657eb']
	}, {
	  name: 'Cosmic Fusion',
	  colors: ['#ff00cc', '#333399']
	}, {
	  name: 'Snapchat',
	  colors: ['#fffc00', '#ffffff']
	}, {
	  name: 'Ed\'s Sunset Gradient',
	  colors: ['#ff7e5f', '#feb47b']
	}, {
	  name: 'Brady Brady Fun Fun',
	  colors: ['#00c3ff', '#ffff1c']
	}, {
	  name: 'Black Ros\xE9',
	  colors: ['#f4c4f3', '#fc67fa']
	}, {
	  name: '80\'s Purple',
	  colors: ['#41295a', '#2F0743']
	}, {
	  name: 'Radar',
	  colors: ['#A770EF', '#CF8BF3', '#FDB99B']
	}, {
	  name: 'Ibiza Sunset',
	  colors: ['#ee0979', '#ff6a00']
	}, {
	  name: 'Dawn',
	  colors: ['#F3904F', '#3B4371']
	}, {
	  name: 'Mild',
	  colors: ['#67B26F', '#4ca2cd']
	}, {
	  name: 'Vice City',
	  colors: ['#3494E6', '#EC6EAD']
	}, {
	  name: 'Jaipur',
	  colors: ['#DBE6F6', '#C5796D']
	}, {
	  name: 'Jodhpur',
	  colors: ['#9CECFB', '#65C7F7', '#0052D4']
	}, {
	  name: 'Cocoaa Ice',
	  colors: ['#c0c0aa', '#1cefff']
	}, {
	  name: 'EasyMed',
	  colors: ['#DCE35B', '#45B649']
	}, {
	  name: 'Rose Colored Lenses',
	  colors: ['#E8CBC0', '#636FA4']
	}, {
	  name: 'What lies Beyond',
	  colors: ['#F0F2F0', '#000C40']
	}, {
	  name: 'Roseanna',
	  colors: ['#FFAFBD', '#ffc3a0']
	}, {
	  name: 'Honey Dew',
	  colors: ['#43C6AC', '#F8FFAE']
	}, {
	  name: 'Under the Lake',
	  colors: ['#093028', '#237A57']
	}, {
	  name: 'The Blue Lagoon',
	  colors: ['#43C6AC', '#191654']
	}, {
	  name: 'Can You Feel The Love Tonight',
	  colors: ['#4568DC', '#B06AB3']
	}, {
	  name: 'Very Blue',
	  colors: ['#0575E6', '#021B79']
	}, {
	  name: 'Love and Liberty',
	  colors: ['#200122', '#6f0000']
	}, {
	  name: 'Orca',
	  colors: ['#44A08D', '#093637']
	}, {
	  name: 'Venice',
	  colors: ['#6190E8', '#A7BFE8']
	}, {
	  name: 'Pacific Dream',
	  colors: ['#34e89e', '#0f3443']
	}, {
	  name: 'Learning and Leading',
	  colors: ['#F7971E', '#FFD200']
	}, {
	  name: 'Celestial',
	  colors: ['#C33764', '#1D2671']
	}, {
	  name: 'Purplepine',
	  colors: ['#20002c', '#cbb4d4']
	}, {
	  name: 'Sha la la',
	  colors: ['#D66D75', '#E29587']
	}, {
	  name: 'Mini',
	  colors: ['#30E8BF', '#FF8235']
	}, {
	  name: 'Maldives',
	  colors: ['#B2FEFA', '#0ED2F7']
	}, {
	  name: 'Cinnamint',
	  colors: ['#4AC29A', '#BDFFF3']
	}, {
	  name: 'Html',
	  colors: ['#E44D26', '#F16529']
	}, {
	  name: 'Coal',
	  colors: ['#EB5757', '#000000']
	}, {
	  name: 'Sunkist',
	  colors: ['#F2994A', '#F2C94C']
	}, {
	  name: 'Blue Skies',
	  colors: ['#56CCF2', '#2F80ED']
	}, {
	  name: 'Chitty Chitty Bang Bang',
	  colors: ['#007991', '#78ffd6']
	}, {
	  name: 'Visions of Grandeur',
	  colors: ['#000046', '#1CB5E0']
	}, {
	  name: 'Crystal Clear',
	  colors: ['#159957', '#155799']
	}, {
	  name: 'Mello',
	  colors: ['#c0392b', '#8e44ad']
	}, {
	  name: 'Compare Now',
	  colors: ['#EF3B36', '#FFFFFF']
	}, {
	  name: 'Meridian',
	  colors: ['#283c86', '#45a247']
	}, {
	  name: 'Relay',
	  colors: ['#3A1C71', '#D76D77', '#FFAF7B']
	}, {
	  name: 'Alive',
	  colors: ['#CB356B', '#BD3F32']
	}, {
	  name: 'Scooter',
	  colors: ['#36D1DC', '#5B86E5']
	}, {
	  name: 'Terminal',
	  colors: ['#000000', '#0f9b0f']
	}, {
	  name: 'Telegram',
	  colors: ['#1c92d2', '#f2fcfe']
	}, {
	  name: 'Crimson Tide',
	  colors: ['#642B73', '#C6426E']
	}, {
	  name: 'Socialive',
	  colors: ['#06beb6', '#48b1bf']
	}, {
	  name: 'Subu',
	  colors: ['#0cebeb', '#20e3b2', '#29ffc6']
	}, {
	  name: 'Shift',
	  colors: ['#000000', '#E5008D', '#FF070B']
	}, {
	  name: 'Clot',
	  colors: ['#070000', '#4C0001', '#070000']
	}, {
	  name: 'Broken Hearts',
	  colors: ['#d9a7c7', '#fffcdc']
	}, {
	  name: 'Kimoby Is The New Blue',
	  colors: ['#396afc', '#2948ff']
	}, {
	  name: 'Dull',
	  colors: ['#C9D6FF', '#E2E2E2']
	}, {
	  name: 'Purpink',
	  colors: ['#7F00FF', '#E100FF']
	}, {
	  name: 'Orange Coral',
	  colors: ['#ff9966', '#ff5e62']
	}, {
	  name: 'Summer',
	  colors: ['#22c1c3', '#fdbb2d']
	}, {
	  name: 'King Yna',
	  colors: ['#1a2a6c', '#b21f1f', '#fdbb2d']
	}, {
	  name: 'Velvet Sun',
	  colors: ['#e1eec3', '#f05053']
	}, {
	  name: 'Zinc',
	  colors: ['#ADA996', '#F2F2F2', '#DBDBDB', '#EAEAEA']
	}, {
	  name: 'Hydrogen',
	  colors: ['#667db6', '#0082c8', '#0082c8', '#667db6']
	}, {
	  name: 'Argon',
	  colors: ['#03001e', '#7303c0', '#ec38bc', '#fdeff9']
	}, {
	  name: 'Lithium',
	  colors: ['#6D6027', '#D3CBB8']
	}, {
	  name: 'Digital Water',
	  colors: ['#74ebd5', '#ACB6E5']
	}, {
	  name: 'Velvet Sun',
	  colors: ['#e1eec3', '#f05053']
	}, {
	  name: 'Orange Fun',
	  colors: ['#fc4a1a', '#f7b733']
	}, {
	  name: 'Rainbow Blue',
	  colors: ['#00F260', '#0575E6']
	}, {
	  name: 'Pink Flavour',
	  colors: ['#800080', '#ffc0cb']
	}, {
	  name: 'Sulphur',
	  colors: ['#CAC531', '#F3F9A7']
	}, {
	  name: 'Selenium',
	  colors: ['#3C3B3F', '#605C3C']
	}, {
	  name: 'Delicate',
	  colors: ['#D3CCE3', '#E9E4F0']
	}, {
	  name: 'Ohhappiness',
	  colors: ['#00b09b', '#96c93d']
	}, {
	  name: 'Lawrencium',
	  colors: ['#0f0c29', '#302b63', '#24243e']
	}, {
	  name: 'Relaxing red',
	  colors: ['#fffbd5', '#b20a2c']
	}, {
	  name: 'Taran Tado',
	  colors: ['#23074d', '#cc5333']
	}, {
	  name: 'Bighead',
	  colors: ['#c94b4b', '#4b134f']
	}, {
	  name: 'Sublime Vivid',
	  colors: ['#FC466B', '#3F5EFB']
	}, {
	  name: 'Sublime Light',
	  colors: ['#FC5C7D', '#6A82FB']
	}, {
	  name: 'Pun Yeta',
	  colors: ['#108dc7', '#ef8e38']
	}, {
	  name: 'Quepal',
	  colors: ['#11998e', '#38ef7d']
	}, {
	  name: 'Sand to Blue',
	  colors: ['#3E5151', '#DECBA4']
	}, {
	  name: 'Wedding Day Blues',
	  colors: ['#40E0D0', '#FF8C00', '#FF0080']
	}, {
	  name: 'Shifter',
	  colors: ['#bc4e9c', '#f80759']
	}, {
	  name: 'Red Sunset',
	  colors: ['#355C7D', '#6C5B7B', '#C06C84']
	}, {
	  name: 'Moon Purple',
	  colors: ['#4e54c8', '#8f94fb']
	}, {
	  name: 'Pure Lust',
	  colors: ['#333333', '#dd1818']
	}, {
	  name: 'Slight Ocean View',
	  colors: ['#a8c0ff', '#3f2b96']
	}, {
	  name: 'eXpresso',
	  colors: ['#ad5389', '#3c1053']
	}, {
	  name: 'Shifty',
	  colors: ['#636363', '#a2ab58']
	}, {
	  name: 'Vanusa',
	  colors: ['#DA4453', '#89216B']
	}, {
	  name: 'Evening Night',
	  colors: ['#005AA7', '#FFFDE4']
	}];
	
	
	var GRADIENTS_HASH = gradients.reduce(function (acc, g) {
	  return _extends({}, acc, _defineProperty({}, g.name.toLowerCase(), g.colors));
	}, {});
	
	var GRADIENT_NAMES = Object.keys(GRADIENTS_HASH);
	
	var randomGradientName = function randomGradientName() {
	  var index = Math.floor(Math.random() * GRADIENT_NAMES.length);
	  return GRADIENT_NAMES[index];
	};
	
	var LinearGradient = function (_Component) {
	  _inherits(LinearGradient, _Component);
	
	  function LinearGradient() {
	    _classCallCheck(this, LinearGradient);
	
	    return _possibleConstructorReturn(this, (LinearGradient.__proto__ || Object.getPrototypeOf(LinearGradient)).apply(this, arguments));
	  }
	
	  _createClass(LinearGradient, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          colors = _props.colors,
	          components = _props.components,
	          offsets = _props.offsets,
	          rest = _objectWithoutProperties(_props, ['name', 'colors', 'components', 'offsets']);
	
	      var finalColors = colors || GRADIENTS_HASH[name || randomGradientName()];
	      var numColors = finalColors.length;
	      var the = {
	        linearGradient: (0, _lodash2.default)(this, 'context.components.linearGradient') || (0, _lodash2.default)(components, 'linearGradient') || 'linearGradient',
	        stop: (0, _lodash2.default)(this, 'context.components.stop') || (0, _lodash2.default)(components, 'stop') || 'stop'
	      };
	
	      return _react2.default.createElement(
	        the.linearGradient,
	        rest,
	        finalColors.map(function (color, i) {
	          return _react2.default.createElement(the.stop, {
	            key: color,
	            stopColor: color
	            // offset={offsets[i]}
	            , offset: offsets[i] || 100 / numColors * i + '%'
	          });
	        })
	      );
	    }
	  }]);
	
	  return LinearGradient;
	}(_react.Component);
	
	LinearGradient.propTypes = {
	  components: _propTypes2.default.shape({
	    linearGradient: _propTypes2.default.node,
	    stop: _propTypes2.default.node
	  }),
	  name: _propTypes2.default.oneOf(GRADIENT_NAMES),
	  colors: _propTypes2.default.array,
	  offsets: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	LinearGradient.defaultProps = {
	  offsets: []
	};
	LinearGradient.contextTypes = {
	  components: _util.types.components
	};
	exports.default = LinearGradient;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSvgTextures = __webpack_require__(700);
	
	var _reactSvgTextures2 = _interopRequireDefault(_reactSvgTextures);
	
	var _util = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Provider = function Provider(WrappedComponent) {
	  var Wrapper = function Wrapper(props, context) {
	    return _react2.default.createElement(WrappedComponent, _extends({}, props, {
	      components: _extends({}, _util.defaultProps.components, context.components || {})
	    }));
	  };
	  Wrapper.contextTypes = {
	    components: _util.types.components
	  };
	  return Wrapper;
	};
	
	exports.default = {
	  Circles: Provider(_reactSvgTextures2.default.Circles),
	  Lines: Provider(_reactSvgTextures2.default.Lines),
	  Paths: Provider(_reactSvgTextures2.default.Paths)
	};

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Pattern = exports.LinearGradient = undefined;
	
	var _LinearGradient = __webpack_require__(217);
	
	var _LinearGradient2 = _interopRequireDefault(_LinearGradient);
	
	var _Pattern = __webpack_require__(218);
	
	var _Pattern2 = _interopRequireDefault(_Pattern);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Axis from './Axis';
	// import AxisBottom from './AxisBottom';
	// import AxisLeft from './AxisLeft';
	// import AxisRight from './AxisRight';
	// import AxisTop from './AxisTop';
	exports.LinearGradient = _LinearGradient2.default;
	exports.Pattern = _Pattern2.default;

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsAstral = '[' + rsAstralRange + ']',
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	  rsUpper + '+' + rsOptUpperContr,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 'ss'
	};
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);
	
	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar--');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__FOO_BAR__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = camelCase;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(707)(module)))

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _textures = __webpack_require__(153);
	
	var _textures2 = _interopRequireDefault(_textures);
	
	var _lodash = __webpack_require__(143);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selection = __webpack_require__(152);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Circles = (_temp2 = _class = function (_Component) {
	  _inherits(Circles, _Component);
	
	  function Circles() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Circles);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      pattern: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Circles.prototype.componentWillMount = function componentWillMount() {
	    this.generate();
	  };
	
	  Circles.prototype.componentDidUpdate = function componentDidUpdate(oldProps) {
	    if (!(0, _lodash2.default)(oldProps, this.props)) this.generate();
	  };
	
	  Circles.prototype.generate = function generate() {
	    var _this2 = this;
	
	    var t = _textures2.default.circles();
	    ['size', 'strokeWidth', 'stroke', 'fill', 'background', 'id', 'complement', 'radius'].forEach(function (key) {
	      if (_this2.props[key]) t[key](_this2.props[key]);
	    });
	    var selection = new _selection2.default();
	    t(selection);
	
	    this.setState({
	      pattern: selection.toReact(this.props.components)
	    });
	  };
	
	  Circles.prototype.render = function render() {
	    return this.state.pattern;
	  };
	
	  return Circles;
	}(_react.Component), _class.displayName = 'Circles', _class.defaultProps = {
	  components: {
	    defs: 'defs',
	    g: 'g',
	    circle: 'circle',
	    rect: 'rect',
	    pattern: 'pattern',
	    path: 'path'
	  }
	}, _temp2);
	exports.default = Circles;
	Circles.propTypes =  false ? {
	  size: _propTypes2.default.number,
	  strokeWidth: _propTypes2.default.number,
	  stroke: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  background: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  complement: _propTypes2.default.bool,
	  radius: _propTypes2.default.number,
	  components: _propTypes2.default.shape({
	    defs: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    g: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    circle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    rect: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    pattern: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    path: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	  })
	} : {};
	module.exports = exports['default'];

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _textures = __webpack_require__(153);
	
	var _textures2 = _interopRequireDefault(_textures);
	
	var _lodash = __webpack_require__(143);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selection = __webpack_require__(152);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Lines = (_temp2 = _class = function (_Component) {
	  _inherits(Lines, _Component);
	
	  function Lines() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Lines);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      pattern: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Lines.prototype.componentWillMount = function componentWillMount() {
	    this.generate();
	  };
	
	  Lines.prototype.componentDidUpdate = function componentDidUpdate(oldProps) {
	    if (!(0, _lodash2.default)(oldProps, this.props)) this.generate();
	  };
	
	  Lines.prototype.generate = function generate() {
	    var _this2 = this;
	
	    var t = _textures2.default.lines();
	    ['size', 'strokeWidth', 'orientation', 'shapeRendering', 'stroke', 'background', 'id'].forEach(function (key) {
	      if (_this2.props[key]) t[key](_this2.props[key]);
	    });
	    var selection = new _selection2.default();
	    t(selection);
	
	    this.setState({
	      pattern: selection.toReact(this.props.components)
	    });
	  };
	
	  Lines.prototype.render = function render() {
	    return this.state.pattern;
	  };
	
	  return Lines;
	}(_react.Component), _class.displayName = 'Lines', _class.defaultProps = {
	  components: {
	    defs: 'defs',
	    g: 'g',
	    circle: 'circle',
	    rect: 'rect',
	    pattern: 'pattern',
	    path: 'path'
	  }
	}, _temp2);
	exports.default = Lines;
	Lines.propTypes =  false ? {
	  size: _propTypes2.default.number,
	  strokeWidth: _propTypes2.default.number,
	  orientation: _propTypes2.default.string,
	  shapeRendering: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  background: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  components: _propTypes2.default.shape({
	    defs: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    g: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    circle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    rect: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    pattern: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    path: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	  })
	} : {};
	module.exports = exports['default'];

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _textures = __webpack_require__(153);
	
	var _textures2 = _interopRequireDefault(_textures);
	
	var _lodash = __webpack_require__(143);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _selection = __webpack_require__(152);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Paths = (_temp2 = _class = function (_Component) {
	  _inherits(Paths, _Component);
	
	  function Paths() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Paths);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      pattern: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Paths.prototype.componentWillMount = function componentWillMount() {
	    this.generate();
	  };
	
	  Paths.prototype.componentDidUpdate = function componentDidUpdate(oldProps) {
	    if (!(0, _lodash2.default)(oldProps, this.props)) this.generate();
	  };
	
	  Paths.prototype.generate = function generate() {
	    var _this2 = this;
	
	    var t = _textures2.default.paths();
	    ['size', 'strokeWidth', 'shapeRendering', 'stroke', 'background', 'id', 'd'].forEach(function (key) {
	      if (_this2.props[key]) t[key](_this2.props[key]);
	    });
	    var selection = new _selection2.default();
	    t(selection);
	
	    this.setState({
	      pattern: selection.toReact(this.props.components)
	    });
	  };
	
	  Paths.prototype.render = function render() {
	    return this.state.pattern;
	  };
	
	  return Paths;
	}(_react.Component), _class.displayName = 'Paths', _class.defaultProps = {
	  components: {
	    defs: 'defs',
	    g: 'g',
	    circle: 'circle',
	    rect: 'rect',
	    pattern: 'pattern',
	    path: 'path'
	  }
	}, _temp2);
	exports.default = Paths;
	Paths.propTypes =  false ? {
	  size: _propTypes2.default.number,
	  strokeWidth: _propTypes2.default.number,
	  d: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['squares', 'nylon', 'waves', 'woven', 'caps', 'crosses', 'hexagons']), _propTypes2.default.func]),
	  shapeRendering: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  background: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  components: _propTypes2.default.shape({
	    defs: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    g: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    circle: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    rect: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    pattern: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    path: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	  })
	} : {};
	module.exports = exports['default'];

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Circles = __webpack_require__(697);
	
	var _Circles2 = _interopRequireDefault(_Circles);
	
	var _Lines = __webpack_require__(698);
	
	var _Lines2 = _interopRequireDefault(_Lines);
	
	var _Paths = __webpack_require__(699);
	
	var _Paths2 = _interopRequireDefault(_Paths);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Circles: _Circles2.default,
	  Lines: _Lines2.default,
	  Paths: _Paths2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(362);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var rand = function rand() {
	  return (Math.random().toString(36) + '00000000000000000').replace(/[^a-z]+/g, '').slice(0, 5);
	};
	
	var Selection = function () {
	  function Selection(tagName) {
	    _classCallCheck(this, Selection);
	
	    this.children = [];
	    this.attrs = {};
	
	    this.tagName = tagName;
	    return this;
	  }
	
	  Selection.prototype.append = function append(tagName) {
	    var child = new Selection(tagName);
	    this.children.push(child);
	    return child;
	  };
	
	  Selection.prototype.attr = function attr(key, value) {
	    this.attrs[(0, _lodash2.default)(key)] = value;
	    return this;
	  };
	
	  Selection.prototype.toReact = function toReact(components) {
	    var children = this.children.map(function (child) {
	      return child.toReact(components);
	    });
	    var the = { component: components[this.tagName] };
	    return this.tagName ? _react2.default.createElement(
	      the.component,
	      _extends({}, this.attrs, { key: this.attrs.id || rand() }),
	      children
	    ) : children[0];
	  };
	
	  return Selection;
	}();
	
	exports.default = Selection;
	module.exports = exports['default'];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	!function(t,r){ true?module.exports=r():"function"==typeof define&&define.amd?define(r):t.textures=r()}(this,function(){"use strict";var t=function(){return(Math.random().toString(36)+"00000000000000000").replace(/[^a-z]+/g,"").slice(0,5)};return{circles:function(){var r=20,n="",e=2,a=!1,u="#343434",i="#343434",c=0,l=t(),o=function(t){var o=t.append("defs").append("pattern").attr("id",l).attr("patternUnits","userSpaceOnUse").attr("width",r).attr("height",r);n&&o.append("rect").attr("width",r).attr("height",r).attr("fill",n),o.append("circle").attr("cx",r/2).attr("cy",r/2).attr("r",e).attr("fill",u).attr("stroke",i).attr("stroke-width",c),a&&[[0,0],[0,r],[r,0],[r,r]].forEach(function(t){o.append("circle").attr("cx",t[0]).attr("cy",t[1]).attr("r",e).attr("fill",u).attr("stroke",i).attr("stroke-width",c)})};return o.heavier=function(t){return 0===arguments.length?e*=2:e*=2*t,o},o.lighter=function(t){return 0===arguments.length?e/=2:e/=2*t,o},o.thinner=function(t){return 0===arguments.length?r*=2:r*=2*t,o},o.thicker=function(t){return 0===arguments.length?r/=2:r/=2*t,o},o.background=function(t){return n=t,o},o.size=function(t){return r=t,o},o.complement=function(t){return a=0===arguments.length||t,o},o.radius=function(t){return e=t,o},o.fill=function(t){return u=t,o},o.stroke=function(t){return i=t,o},o.strokeWidth=function(t){return c=t,o},o.id=function(t){return 0===arguments.length?l:(l=t,o)},o.url=function(){return"url(#"+l+")"},o},lines:function(){var r=20,n="#343434",e=2,a="",u=t(),i=["diagonal"],c="auto",l=function(t){var n=r;switch(t){case"0/8":case"vertical":return"M "+n/2+", 0 l 0, "+n;case"1/8":return"M "+n/4+",0 l "+n/2+","+n+" M "+-n/4+",0 l "+n/2+","+n+" M "+3*n/4+",0 l "+n/2+","+n;case"2/8":case"diagonal":return"M 0,"+n+" l "+n+","+-n+" M "+-n/4+","+n/4+" l "+n/2+","+-n/2+" M "+.75*n+","+5/4*n+" l "+n/2+","+-n/2;case"3/8":return"M 0,"+.75*n+" l "+n+","+-n/2+" M 0,"+n/4+" l "+n+","+-n/2+" M 0,"+5*n/4+" l "+n+","+-n/2;case"4/8":case"horizontal":return"M 0,"+n/2+" l "+n+",0";case"5/8":return"M 0,"+-n/4+" l "+n+","+n/2+"M 0,"+n/4+" l "+n+","+n/2+" M 0,"+3*n/4+" l "+n+","+n/2;case"6/8":return"M 0,0 l "+n+","+n+" M "+-n/4+","+.75*n+" l "+n/2+","+n/2+" M "+3*n/4+","+-n/4+" l "+n/2+","+n/2;case"7/8":return"M "+-n/4+",0 l "+n/2+","+n+" M "+n/4+",0 l "+n/2+","+n+" M "+3*n/4+",0 l "+n/2+","+n;default:return"M "+n/2+", 0 l 0, "+n}},o=function(t){var o=t.append("defs").append("pattern").attr("id",u).attr("patternUnits","userSpaceOnUse").attr("width",r).attr("height",r);a&&o.append("rect").attr("width",r).attr("height",r).attr("fill",a),i.forEach(function(t){o.append("path").attr("d",l(t)).attr("stroke-width",e).attr("shape-rendering",c).attr("stroke",n).attr("stroke-linecap","square")})};return o.heavier=function(t){return 0===arguments.length?e*=2:e*=2*t,o},o.lighter=function(t){return 0===arguments.length?e/=2:e/=2*t,o},o.thinner=function(t){return 0===arguments.length?r*=2:r*=2*t,o},o.thicker=function(t){return 0===arguments.length?r/=2:r/=2*t,o},o.background=function(t){return a=t,o},o.size=function(t){return r=t,o},o.orientation=function(){for(var t=arguments.length,r=Array(t),n=0;n<t;n++)r[n]=arguments[n];return 0===arguments.length?o:(i=r,o)},o.shapeRendering=function(t){return c=t,o},o.stroke=function(t){return n=t,o},o.strokeWidth=function(t){return e=t,o},o.id=function(t){return 0===arguments.length?u:(u=t,o)},o.url=function(){return"url(#"+u+")"},o},paths:function(){var r=1,n=1,e=20,a="#343434",u=2,i="",c=function(t){return"M "+t/4+","+3*t/4+"l"+t/4+","+-t/2+"l"+t/4+","+t/2},l=t(),o="transparent",s="auto",f=function(t){var a=e;switch(t){case"squares":return"M "+a/4+" "+a/4+" l "+a/2+" 0 l 0 "+a/2+" l "+-a/2+" 0 Z";case"nylon":return"M 0 "+a/4+" l "+a/4+" 0 l 0 "+-a/4+" M "+3*a/4+" "+a+" l 0 "+-a/4+" l "+a/4+" 0 M "+a/4+" "+a/2+" l 0 "+a/4+" l "+a/4+" 0 M "+a/2+" "+a/4+" l "+a/4+" 0 l 0 "+a/4;case"waves":return"M 0 "+a/2+" c "+a/8+" "+-a/4+" , "+3*a/8+" "+-a/4+" , "+a/2+" 0 c "+a/8+" "+a/4+" , "+3*a/8+" "+a/4+" , "+a/2+" 0 M "+-a/2+" "+a/2+" c "+a/8+" "+a/4+" , "+3*a/8+" "+a/4+" , "+a/2+" 0 M "+a+" "+a/2+" c "+a/8+" "+-a/4+" , "+3*a/8+" "+-a/4+" , "+a/2+" 0";case"woven":return"M "+a/4+","+a/4+"l"+a/2+","+a/2+"M"+3*a/4+","+a/4+"l"+a/2+","+-a/2+" M"+a/4+","+3*a/4+"l"+-a/2+","+a/2+"M"+3*a/4+","+5*a/4+"l"+a/2+","+-a/2+" M"+-a/4+","+a/4+"l"+a/2+","+-a/2;case"crosses":return"M "+a/4+","+a/4+"l"+a/2+","+a/2+"M"+a/4+","+3*a/4+"l"+a/2+","+-a/2;case"caps":return"M "+a/4+","+3*a/4+"l"+a/4+","+-a/2+"l"+a/4+","+a/2;case"hexagons":return r=3,n=Math.sqrt(3),"M "+a+",0 l "+a+",0 l "+a/2+","+a*Math.sqrt(3)/2+" l "+-a/2+","+a*Math.sqrt(3)/2+" l "+-a+",0 l "+-a/2+","+-a*Math.sqrt(3)/2+" Z M 0,"+a*Math.sqrt(3)/2+" l "+a/2+",0 M "+3*a+","+a*Math.sqrt(3)/2+" l "+-a/2+",0";default:return t(a)}},h=function(t){var h=f(c),d=t.append("defs").append("pattern").attr("id",l).attr("patternUnits","userSpaceOnUse").attr("width",e*r).attr("height",e*n);i&&d.append("rect").attr("width",e*r).attr("height",e*n).attr("fill",i),d.append("path").attr("d",h).attr("fill",o).attr("stroke",a).attr("stroke-width",u).attr("stroke-linecap","square").attr("shape-rendering",s)};return h.heavier=function(t){return 0===arguments.length?u*=2:u*=2*t,h},h.lighter=function(t){return 0===arguments.length?u/=2:u/=2*t,h},h.thinner=function(t){return 0===arguments.length?e*=2:e*=2*t,h},h.thicker=function(t){return 0===arguments.length?e/=2:e/=2*t,h},h.background=function(t){return i=t,h},h.shapeRendering=function(t){return s=t,h},h.size=function(t){return e=t,h},h.d=function(t){return c=t,h},h.fill=function(t){return o=t,h},h.stroke=function(t){return a=t,h},h.strokeWidth=function(t){return u=t,h},h.id=function(t){return 0===arguments.length?l:(l=t,h)},h.url=function(){return"url(#"+l+")"},h}}});


/***/ }),

/***/ 707:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBsGrid = __webpack_require__(34);
	
	var _reactBodyClassname = __webpack_require__(33);
	
	var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactFeather = __webpack_require__(75);
	
	var _element = __webpack_require__(54);
	
	var _extra = __webpack_require__(219);
	
	var _gatsbyLink = __webpack_require__(74);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactWindowSize = __webpack_require__(53);
	
	var _reactWindowSize2 = _interopRequireDefault(_reactWindowSize);
	
	var _get = __webpack_require__(103);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactFab = __webpack_require__(105);
	
	var _Space = __webpack_require__(36);
	
	var _Space2 = _interopRequireDefault(_Space);
	
	var _Title = __webpack_require__(84);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Page = __webpack_require__(35);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global graphql */
	
	
	var Extra = function (_Component) {
	  _inherits(Extra, _Component);
	
	  function Extra() {
	    _classCallCheck(this, Extra);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Extra.prototype.componentDidMount = function componentDidMount() {
	    if (Prism) Prism.highlightAll();
	  };
	
	  Extra.prototype.getDocs = function getDocs() {
	    var edges = (0, _get2.default)(this.props, 'data.allMarkdownRemark.edges');
	    if (!edges) return '';
	    var html = edges.filter(function (edge) {
	      return edge.node.html.indexOf('name="extras"') > -1;
	    })[0].node.html;
	
	    return html.slice(html.indexOf('<h2>'));
	  };
	
	  Extra.prototype.scrollTo = function scrollTo(key) {
	    return function () {
	      document.querySelector('[name="elements__' + key + '"]').scrollIntoView({
	        behavior: 'smooth',
	        block: 'center',
	        inline: 'nearest'
	      });
	    };
	  };
	
	  Extra.prototype.render = function render() {
	    var _props = this.props,
	        windowWidth = _props.windowWidth,
	        windowHeight = _props.windowHeight;
	
	    var height = windowHeight;
	    var patternsWidth = windowWidth;
	    return _react2.default.createElement(
	      _reactBodyClassname2.default,
	      { className: 'no-padding' },
	      _react2.default.createElement(
	        _Page2.default,
	        { fluid: true, name: 'page-build' },
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: 'Potion.js - React + D3',
	          meta: [{
	            property: 'og:url',
	            content: 'http://numberpicture.com/build'
	          }, {
	            property: 'og:title',
	            content: 'Potion.js - React + D3'
	          }, {
	            property: 'og:description',
	            content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.'
	          }, {
	            name: 'twitter:title',
	            content: 'Potion.js - React + D3'
	          }, {
	            name: 'twitter:description',
	            content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.'
	          }, {
	            charSet: 'utf-8'
	          }]
	        }),
	        _react2.default.createElement(
	          _reactFab.Fab,
	          { style: { right: '20px', bottom: '20px' } },
	          _react2.default.createElement(
	            _reactFab.FabButton,
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: this.scrollTo('top') },
	              _react2.default.createElement(_reactFeather.ChevronUp, null)
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactBsGrid.Container,
	          { fluid: true },
	          _react2.default.createElement(
	            _reactBsGrid.Row,
	            null,
	            _react2.default.createElement(
	              _reactBsGrid.Container,
	              null,
	              _react2.default.createElement(
	                _reactBsGrid.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { lg: 12 },
	                  _react2.default.createElement('div', { name: 'elements__top' }),
	                  _react2.default.createElement(
	                    _Title2.default,
	                    null,
	                    'Extras'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactBsGrid.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBsGrid.Col,
	                  { lg: 8 },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Potion Extras are presentational React components that can be used to enrich visualizations visually. Use them to add fill effects and other meta elements to the canvas like axes, legends and gridlines (still in development).'
	                  )
	                ),
	                _react2.default.createElement(_Space2.default, { half: true })
	              )
	            ),
	            _react2.default.createElement(
	              _reactBsGrid.Container,
	              { fluid: true },
	              _react2.default.createElement(
	                _reactBsGrid.Row,
	                null,
	                _react2.default.createElement(
	                  _reactBsGrid.Container,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Patterns'
	                  )
	                ),
	                _react2.default.createElement(
	                  _element.Svg,
	                  { width: windowWidth, height: windowHeight },
	                  _react2.default.createElement(_extra.Pattern.Lines, {
	                    id: 'lines1',
	                    strokeWidth: 1,
	                    stroke: 'black',
	                    size: 10,
	                    orientation: 'diagonal',
	                    background: 'white'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Lines, {
	                    id: 'lines2',
	                    strokeWidth: 1,
	                    stroke: 'black',
	                    size: 10,
	                    orientation: 'vertical',
	                    background: 'white'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Lines, {
	                    id: 'lines3',
	                    strokeWidth: 1,
	                    stroke: 'black',
	                    size: 12,
	                    orientation: 'horizontal',
	                    background: 'white'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Circles, {
	                    id: 'circles1'
	                    // strokeWidth={1}
	                    , radius: 1,
	                    stroke: 'black',
	                    size: 10,
	                    background: 'white'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Circles, {
	                    id: 'circles2',
	                    strokeWidth: 1,
	                    stroke: 'black',
	                    background: 'white',
	                    radius: 4,
	                    fill: 'transparent'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Paths, {
	                    id: 'paths1',
	                    strokeWidth: 1,
	                    size: 16,
	                    stroke: 'black',
	                    background: 'white',
	                    d: 'nylon',
	                    fill: 'transparent'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Paths, {
	                    id: 'paths2',
	                    strokeWidth: 1,
	                    size: 16,
	                    stroke: 'black',
	                    background: 'white',
	                    d: 'waves',
	                    fill: 'transparent'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Paths, {
	                    id: 'paths3',
	                    strokeWidth: 1,
	                    size: 16,
	                    stroke: 'black',
	                    background: 'white',
	                    d: 'woven',
	                    fill: 'transparent'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Paths, {
	                    id: 'paths4',
	                    strokeWidth: 1,
	                    size: 16,
	                    stroke: 'black',
	                    background: 'white',
	                    d: 'caps',
	                    fill: 'transparent'
	                  }),
	                  _react2.default.createElement(_extra.Pattern.Paths, {
	                    id: 'paths5',
	                    strokeWidth: 1,
	                    size: 16,
	                    stroke: 'black',
	                    background: 'white',
	                    d: 'crosses',
	                    fill: 'transparent'
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#lines2)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: 0,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#lines1)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#lines3)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 2,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#circles1)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 3,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#paths1)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 4,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#circles2)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: 0,
	                    y: height / 2
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#paths2)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5,
	                    y: height / 2
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#paths3)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 2,
	                    y: height / 2
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#paths4)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 3,
	                    y: height / 2
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#paths5)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 4,
	                    y: height / 2
	                  })
	                ),
	                _react2.default.createElement(_Space2.default, null),
	                _react2.default.createElement(
	                  _reactBsGrid.Container,
	                  null,
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Gradients'
	                  )
	                ),
	                _react2.default.createElement(
	                  _element.Svg,
	                  { width: windowWidth, height: windowHeight },
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient1',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient2',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient3',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient4',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient5',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient6',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient7',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient8',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient9',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_extra.LinearGradient, {
	                    id: 'gradient10',
	                    x1: '0%',
	                    y1: '0%',
	                    x2: '0%',
	                    y2: '100%'
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient1)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: 0,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient2)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient3)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 2,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient4)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 3,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient5)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 4,
	                    y: 0
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient6)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: 0,
	                    y: height / 2
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient7)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5,
	                    y: height / 2
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient8)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 2,
	                    y: height / 2
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient9)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 3,
	                    y: height / 2
	                  }),
	                  _react2.default.createElement(_element.Rect, {
	                    fill: 'url(#gradient10)',
	                    height: height / 2,
	                    width: patternsWidth / 5,
	                    x: patternsWidth / 5 * 4,
	                    y: height / 2
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactBsGrid.Container,
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'page page-docs' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content' },
	                  _react2.default.createElement('div', {
	                    dangerouslySetInnerHTML: {
	                      __html: this.getDocs()
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(_Space2.default, null),
	              _react2.default.createElement(_Space2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Extra;
	}(_react.Component);
	
	exports.default = (0, _reactWindowSize2.default)(Extra);
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-extras-js-6758c0bd6469377ec628.js